import { createFileRoute, Outlet } from '@tanstack/react-router';
import ReceptionPortal from '../../components/portals/ReceptionPortal';

export const Route = createFileRoute('/reception/orders')({
  component: ReceptionOrdersRoute,
});

function ReceptionOrdersRoute() {
  return (
    <ReceptionPortal>
      <Outlet />
    </ReceptionPortal>
  );
}
